<script setup lang="ts">
import { LINKS } from "../constants/links";

const emit = defineEmits(["close"]);
</script>

<template>
    <div class="ams-handoff-modal">
        <img
            src="../assets/images/logos-large.svg"
            alt="annuity ready provider panel logos"
        >
        <div class="welcome-row">
            <img
                class="welcome-banner"
                src="../assets/images/welcome-banner.svg"
                alt="annuity ready welcome banner"
            >
            <div class="welcome-text">
                <div>
                    <h3 class="blue">
                        Let’s help you find a better annuity income.
                    </h3>
                    <p class="handover-col">
                        Ready to compare annuity rates from our panel of leading providers?
                        Using the information you've provided to Legal & General, we'll search the open market to see if we can find you a better annuity income for your retirement.
                    </p>
                </div>
            </div>
        </div>
        <hr>
        <div class="consent">
            <span>
                By clicking the ‘Agree & Continue’ button, I/we consent to Annuity Ready processing the information including lifestyle, health and medical details that I/we have provided or provide, in accordance with the Annuity Ready <a
                    :href="LINKS.ANNUITY_TERMS_AND_CONDITIONS_DOCUMENT_LINK"
                    target="_blank"
                >Terms &amp; Conditions</a> and
                <a
                    :href="LINKS.ANNUITY_PRIVACY_NOTICE_DOCUMENT_LINK"
                    target="_blank"
                >Privacy Notice</a> which contains details of providers with whom they may share the data to obtain annuity quotes.
            </span>
            <button
                id="agree_and_continue"
                type="button"
                class="mt-4 mb-2 btn btn-secondary"
                @click="emit('close')"
            >
                Agree & Continue
            </button>
        </div>
    </div>
</template>

<style scoped>
.ams-handoff-modal {
    display: flex;
    flex-direction: column;
    text-align: center;
}

.ams-handoff-modal .welcome-row {
    display: flex;
    column-gap: 30px;
    padding: 0 20px;
}

.ams-handoff-modal .welcome-row .welcome-banner {
    width: 50%;
    flex-shrink: 0;
}

.ams-handoff-modal .welcome-row .welcome-text {
    padding-top: 45px;
}
.ams-handoff-modal .welcome-row .welcome-text h3 {
    margin-bottom: 20px;
}

.ams-handoff-modal .consent {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 20px;
    font-size: 16px;
}

.ams-handoff-modal hr {
    display: none;
}

@media screen and (max-width: 1200px) {
    .ams-handoff-modal .welcome-row {
        flex-direction: column;
    }
    .ams-handoff-modal .welcome-row .welcome-banner {
        margin-top: 20px;
        width: 100%;
        max-height: 300px;
    }

    .ams-handoff-modal hr {
        display: block;
        margin-top: 30px;
        margin-bottom: 10px;
    }
    .ams-handoff-modal .consent {
        margin-top: 20px;
    }
}
</style>
